<div class="question-pull" [id]="'specified-items-accordion'">
  @for (item of enteredItems; track item; let i = $index; let last = $last) {
    <div class="card card--freeform">
      <a [href]="'#' + (item?.RegistrationNumber ? removeSpaces(item?.RegistrationNumber) : 'add-item') + '-' + (i +1)"
        class="card-title"
        data-toggle="collapse" aria-expanded="false" [class.collapsed]="item.RegistrationNumber || !last">
        <div class="card-title__text">
          <svg class="icon icon--lg">
            <use [attr.xlink:href]="'#cart-discount'"></use>
          </svg>
          <div class="card-title__text-wrap">
            <h4>{{item?.RegistrationNumber ? item?.RegistrationNumber : 'Add item'}}</h4>
            <p>{{questionService?.accounting.formatMoney(item?.Value)}}</p>
          </div>
        </div>
        <div class="card-title__cost is-active">
          <p><strong>{{questionService?.accounting.formatMoney(item?.Premium)}}</strong> /mo</p>
        </div>
        <div class="card-title__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
      <div class="card-body collapse"
        [id]="(item?.RegistrationNumber ? removeSpaces(item?.RegistrationNumber) : 'add-item') + '-' + (i +1)"
        [attr.data-parent]="'#specified-items-accordion'" [class.show]="!item.RegistrationNumber || last">
        <div class="card__content">
          <!--<app-question-controller *ngFor="let q of childrenQuestions" [question]="q" (questionAnswer)="onInputChange()">
        </app-question-controller>-->
        <div class="form-group form-group--sm">
          <label>Registration Number</label>
          <input
            type="text"
            placeholder="Registration Number"
            (keyup)="upperCaseRegistration(i)"
            (keypress)="upperCaseRegistration(i)"
            [(ngModel)]="item.RegistrationNumber"
            class="form-control"
            (ngModelChange)="onInputChange()"
            [name]="uniqueRegNumberName + '-' + i">
          </div>
          <div class="form-group form-group--sm">
            <label>Vehicle Value</label>
            <input
              currencyMask type="text" class="form-control currency" autocomplete="off" [name]="uniqueValueName + '-' + i"
              [(ngModel)]="item.Value" (ngModelChange)="onInputChange()"
            [placeholder]="questionService?.accounting.formatMoney(question?.min_val) + ' - ' +
            questionService?.accounting.formatMoney(question?.max_val)"
              [options]="maskOptions">
            </div>
            <div class="form-group form-group--sm ui-front">
              <app-question-dropdown
                [options]="options"
                [showLabel]="true"
                [selectedValue]="item.TrackingDevice"
                [labelText]="'Tracking Device'"
                (questionAnswer)="selectChange($event, i)">
              </app-question-dropdown>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- /card -->
  </div>
